import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { certifications } from '../data/mock';

const Certifications = () => {
  return (
    <section className="py-24 bg-[#F2F2F2]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A192F] mb-4">
            Calidad y garantía que{' '}
            <span className="text-[#FFD700]">marcan la diferencia</span>
          </h2>
          <p className="text-lg text-[#0A192F]/80 max-w-3xl mx-auto">
            Todos nuestros productos están fabricados con materiales certificados y cuentan con 2 años de garantía. Cumplimos los estándares europeos de resistencia y durabilidad, garantizando una inversión segura.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              <CheckCircle2 className="w-6 h-6 text-[#FFD700] flex-shrink-0 mt-1" />
              <p className="text-[#0A192F] text-lg">{cert}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;